// extracted by mini-css-extract-plugin
module.exports = {"scrollButtonWrapper":"ScrollButton_scrollButtonWrapper__aY7Jk"};